import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { unifyOrder } from '@/services';
import { errorOrders } from '@/utils/errors';
import PopUnifyAccounts from '../unify-accounts';

interface SimpleDialogProps {
  // eslint-disable-next-line react/no-unused-prop-types
  open?: boolean;
  value: string;
  onClose: (value: string) => void;
}

export function DialogUnifyAccounts(props: SimpleDialogProps) {
  const { onClose, value } = props;
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    onClose(value);
  };

  const { mutate: mutateChangeMethod } = useMutation({
    mutationFn: unifyOrder,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['orders', 'open_orders'] });
      enqueueSnackbar('Se unifico las cuentas con exito!');
      handleClose();
    },
    onError: (error: any) => {
      const newMessage = errorOrders[error.error ?? ''];
      if (newMessage) {
        enqueueSnackbar(newMessage.label, { variant: 'error' });
      } else {
        enqueueSnackbar('Problemas unificando cuentas', { variant: 'error' });
      }
    },
  });

  return <PopUnifyAccounts lastId={value} onSave={mutateChangeMethod} />;
}
